export default "__VITE_ASSET__4786280f__"